<template>
  <b-modal
    ref="modal"
    size="lg"
    title="Folder settings"
    centered
    :no-enforce-focus="true"
    @hide="handleCloseModal"
    @show="fetchData"
  >
    <div
      v-if="isLoading"
      class="justify-content-center align-items-center loading"
      style="position: absolute; top: 0; left: 0; bottom: 0; right: 0; background: #ffffffb0; z-index: 999; display: flex;"
    >
      <div
        class="spinner-border text-primary"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <template #modal-footer>
      <ButtonPrimary
        variant="primary"
        @click="save"
      >
        Save
      </ButtonPrimary>
      <ButtonOutline
        variant="outline-primary"
        @click="$refs.modal.hide()"
      >
        Cancel
      </ButtonOutline>
    </template>
    <b-alert
      show
      variant="info"
    >
      Please note, if none selected - all company members have access to this {{ selectedItems[0]?.type ?? '' }}.
    </b-alert>
    <h3><b>User groups</b> who have access to the folder</h3>
    <InputTags
      :items="userGroupsOptions"
      :selected-items="userGroupsSelected"
      placeholder="Select groups"
      @itemsChanged="handleGroupsChange"
    />
    <h3><b>Users</b> who have access to the folder</h3>
    <InputTags
      :items="userOptions"
      :selected-items="usersSelected"
      placeholder="Select users"
      @itemsChanged="handleUsersChange"
    />
  </b-modal>
</template>

<script>
import ButtonPrimary from "@frontend/components/common/atoms/ButtonPrimary.vue";
import ButtonOutline from "@frontend/components/common/atoms/ButtonOutline.vue";
import InputTags from "@frontend/components/common/folders/TagsComponent.vue";
import modalMixin from './mixin'
import { createNamespacedHelpers } from 'vuex'
import Requests from "@frontend/services/api/file-browser";
import {TABS} from "@frontend/components/modules/file-browser/constants";

const { mapActions, mapGetters } = createNamespacedHelpers('fileBrowser')

export default {
  name: "LayoutFolderSettings",
  components: {ButtonOutline, ButtonPrimary, InputTags},
  mixins: [
    modalMixin
  ],
  props: {
    payload: {
      type: Object,
      default: () => ({})
    }
  },
  
  data: () => ({
    name: '',
    userOptions: [],
    usersSelected: [],
    userGroupsOptions: [],
    userGroupsSelected: [],
    isLoading: false
  }),
  computed: {
    ...mapGetters(['selectedItems', 'selected']),
    currentTab() {
      if (this.$route.params.tab === TABS.FILES) {
        return TABS.FILES;
      }
      return TABS.PRODUCTS;
    }
  },
  watch: {
    payload(value) {
      if (!value) {
        return;
      }

      this.name = value.name
    }
  },
  methods: {
    handleCloseModal() {
      this.closeHandler();
    },
    handleUsersChange(items) {
      this.usersSelected = items;
    },
    handleGroupsChange(items) {
      this.userGroupsSelected = items;
    },
    async fetchData() {
      this.isLoading = true;
      const availablePermissions = await Requests.getFolderAvailablePermissions();
      const folderPermissionsData = await Requests.getFolderPermissionsData(this.selected, this.currentTab);
      
      this.userOptions = availablePermissions.data.users.map(user => {
        return {
          id: user.id,
          name: user.full_name,
        };
      });

      this.userGroupsOptions = availablePermissions.data.userGroups.map(group => {
        return {
          id: group.id,
          name: group.name
        };
      });

      this.usersSelected = folderPermissionsData.data.users;
      this.userGroupsSelected = folderPermissionsData.data.userGroups;
      
      this.isLoading = false;
    },
    async save() {
      await Requests.syncFolderPermissions(
        this.selected,
        this.usersSelected.map(user => user.id),
        this.userGroupsSelected.map(group => group.id),
        this.currentTab
      );

      toastr.success('Folder settings updated successfully')
      this.close();
    }
  }
}
</script>

<style scoped lang="scss">
h3 {
  font-size: 18px;
  margin:15px 0;
  
  &:first-child {
    margin-top: 0;
  }
}
</style>
